var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"license"},_vm._l((_vm.img),function(item,i){return (_vm.$route.query.id - 0 === i)?_c('div',{key:i,staticClass:"zzhao"},[_c('img',{staticClass:"banner_img",attrs:{"src":item.img,"alt":""}})]):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13efa1cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/License.vue
// module id = null
// module chunks = 